import { render, staticRenderFns } from "./TaskStateSelect.vue?vue&type=template&id=05dd6122&"
import script from "./TaskStateSelect.vue?vue&type=script&lang=js&"
export * from "./TaskStateSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports